import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Paper, Slide, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import {
  BubbleNotification,
  FIDES_CHAT_BUBBLE_MAX_WIDTH,
  FIDES_CHAT_TRAY_EDGE_OFFSET,
  FIDES_CHAT_TRAY_RIGHT_OFFSET,
} from './fidesChatTrayUtils';

interface FidesChatBubbleNotificationProps {
  bubble: BubbleNotification | null;
  onOpenConversation: (conversationId: string) => void;
  onDismiss: () => void;
}

export function FidesChatBubbleNotification({
  bubble,
  onOpenConversation,
  onDismiss,
}: FidesChatBubbleNotificationProps) {
  return (
    <Slide direction="up" in={bubble !== null} mountOnEnter unmountOnExit>
      <Paper
        elevation={6}
        onClick={() => {
          if (bubble) {
            onOpenConversation(bubble.conversationId);
            onDismiss();
          }
        }}
        sx={{
          position: 'fixed',
          bottom: FIDES_CHAT_TRAY_EDGE_OFFSET + 64 + 16,
          right: FIDES_CHAT_TRAY_RIGHT_OFFSET,
          width: FIDES_CHAT_BUBBLE_MAX_WIDTH,
          zIndex: 1301,
          cursor: 'pointer',
          borderRadius: 2.5,
          p: 1.5,
          pr: 4,
          backgroundColor: Palette.default.buttonBg,
          color: '#fff',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -8,
            right: 22,
            width: 0,
            height: 0,
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: `8px solid ${Palette.default.buttonBg}`,
          },
          '&:hover': {
            backgroundColor: Palette.default.text,
            '&::after': {
              borderTopColor: Palette.default.text,
            },
          },
        }}
      >
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss();
          }}
          aria-label="Dismiss notification"
          sx={{ position: 'absolute', top: 4, right: 4, color: 'rgba(255,255,255,0.7)', p: 0.5 }}
        >
          <CloseIcon sx={{ fontSize: 14 }} />
        </IconButton>
        <Typography
          variant="caption"
          fontWeight={700}
          sx={{ display: 'block', mb: 0.25, opacity: 0.85 }}
        >
          {bubble?.name}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.8rem',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            lineHeight: 1.4,
          }}
        >
          {bubble?.text}
        </Typography>
      </Paper>
    </Slide>
  );
}
